import { render, staticRenderFns } from "./group_role_management.vue?vue&type=template&id=e6a0fa4e&"
import script from "./group_role_management.vue?vue&type=script&lang=js&"
export * from "./group_role_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports